<template>
  <div class="pt-4 px-8 text-sm lg:text-base">
    <!-- <transition-group name="fade" tag="div"> -->
    <KioskOrderItem
      v-for="(data, index) in collectedCartItems"
      v-bind="{
        ...data,
        index,
      }"
      :key="index"
      blockUpselling
    />

    <!-- </transition-group> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import { sortCartByAdditions } from "../utils";
import lang from "../lang";
import KioskOrderItem from "./KioskOrderItem.vue";

export default {
  props: {
    backgroundColor: String,
  },
  data() {
    return {
      lang,
      additionPrice: [],
      filteredAdditionPrice: null,
    };
  },
  components: {
    KioskOrderItem,
  },
  computed: {
    ...mapGetters(["language"]),
    ...mapGetters("Cart", ["cartItems"]),
    ...mapGetters("Theme", [
      "paymentFloatBackground",
      "text",
      "borderMain",
      "processTekst",
      "buttonImgColors",
      "btnDestructiveIcon",
      "kioskItemOverviewBorder",
      "kioskPriceColor",
      "addMoreItemsIconBackground",
      "addMoreItemsNumber",
      "customThemeVariables",
      "btnThirdText",
    ]),
    collectedCartItems() {
      const items = this.cartItems;
      const result = sortCartByAdditions(items);
      return result;
    },
  },
  methods: {
    // add item to the cart and update order or open de modifier modals
    addToCart(item) {
      this.$store.commit("updateItemPrice", item.price);
      this.$store.commit("Cart/updateOrderItemCount", 1);

      this.currentItem = item;
      this.$store.commit("updateCategoryId", item.MenuCategoryId);

      this.itemBeingAdded = this.currentItem.Id;
      this.$store
        .dispatch("Cart/GET_MENU_ITEM_ORDERING", this.currentItem.Id)
        .then(() => {
          this.itemBeingAdded = "";
          this.$store.dispatch("Cart/UPDATE_ORDER", {
            operation: "add",
            item: this.currentItem,
          });
          setTimeout(() => (this.disableAddButton = false), 150);
        })
        .catch(() => {
          this.itemBeingAdded = "";
        });
    },
    // calculates the correct price of the item
    correctItemPrice() {
      if (this.cartItems) {
        let additionItemPrice = 0;
        let object = {};
        this.cartItems.map((x) => {
          additionItemPrice = 0;
          if (x.OrderItemAdditions) {
            if (x.OrderItemAdditions.length == 0) {
              object = {
                id: x.Id,
                price: 0,
              };
              this.additionPrice.push(object);
            }
            x.OrderItemAdditions.map((y) => {
              additionItemPrice += y.Addition.price;
              object = {
                id: x.Id,
                price: additionItemPrice,
              };
            });
            this.additionPrice.push(object);
            this.filteredAdditionPrice = _.uniqWith(
              this.additionPrice,
              _.isEqual
            );
          } else {
            object = {
              id: x.Id,
              price: 0,
            };
            this.additionPrice.push(object);
          }
        });
      }
    },
  },
  created() {
    this.correctItemPrice();
  },
};
</script>

<style scoped>
.absoluteDeleteButton {
  position: absolute;
  top: -15px;
  right: -15px;
}
</style>
